import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Loader from '../shared/loader';
import Api from '../api/api';
import stringHelpers from '../../utilities/stringHelpers'
import arrayUtilities from '../../utilities/arrayUtilities'
import { Modal, Button } from 'react-bootstrap';
import {ErrorModal} from '../../utilities/errorModal'

export default function LetterTemplates(props) {
    const [availableDocuments, setAvailableDocuments] = useState(null);
    const [copyId, setCopyId] = useState(null);
    const [copyNewName, setCopyNewName] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const getDocuments = function () {
        setIsLoading(true)
        Api.getLetterTemplates(
            (data) => {
                setAvailableDocuments(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            props.organisationId,
            props.token
        )
    };

    useEffect(() => {
        getDocuments();
    }, [])

    const handleCopyConfirm = () => {
        setIsLoading(true)
        Api.copyLetterTemplate(
            props.organisationId, copyId, copyNewName,
            data => {
                if (data.isError) {
                    setIsLoading(false)
                    setErrorMessage(data.errorMessage)
                } else {
                    getDocuments()
                }
            },
            error => {
                setIsLoading(false)
                setErrorMessage(error.errorMessage)
            },
            props.token
        )
        setCopyNewName(null)
        setCopyId(null)
    }

    var addNewDocUrl = "/organisation/" + props.organisationId + "/document-template";
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                          <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center justify-content-between">
                                    <div className="col-auto d-flex align-items-center pr-0">
                                        <h5 className="mb-0">Letter Templates</h5>
                                    </div>
                                    <div className="col-auto ml-auto text-right pl-0 filter-buttons-wrapper">
                                        <Link to={addNewDocUrl} className="btn btn-falcon-default btn-sm"><i className="fas fa-plus"></i> New</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-sm table-striped fs--1 mb-0">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th className='align-middle'>Name</th>
                                            <th className="text-center align-middle">Status</th>
                                            <th className="align-middle"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        isLoading 
                                        ? <tr>
                                            <td colSpan={3}>
                                                <Loader />
                                            </td></tr>
                                        : <>
                                            {
                                            !arrayUtilities.isNullOrEmpty(availableDocuments) && availableDocuments.map((doc) => {
                                            var url = addNewDocUrl + "/" + doc.id;
                                            var charge;
                                            if(doc.additionalChargeType === 0){
                                                charge = '£' + (Math.round(doc.additionalCharge * 100) / 100).toFixed(2);
                                            } else {
                                                charge = doc.additionalCharge + '%';
                                            }
                                            return (
                                                <tr>
                                                    <td className='align-middle'><Link to={url}><h6 className="mb-0">{doc.name}</h6></Link></td>
                                                    <td className="text-center align-middle">{doc.isActive && <><i className="fas fa-check text-success"></i></>}{!doc.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                    <td className="text-right align-middle">
                                                        <button className="btn btn-falcon-default btn-link btn-sm py-2 dropdown-toggle dropdown-caret-none mr-3" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                                        <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                            <Link to={url} type="button" className="dropdown-item btn-sm">Edit</Link>
                                                            <button type="button" className="dropdown-item btn-sm" onClick={() => {
                                                                setCopyId(doc.id)
                                                                setCopyNewName(`${doc.name} (copy)`)
                                                            }}>Copy</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    !stringHelpers.isNullOrEmpty(copyId) && !stringHelpers.isNullOrEmpty(copyNewName)
                    && <Modal show onHide={ () => {setCopyId(null); setCopyNewName(null)} } centered>
                        <Modal.Header>
                            <Modal.Title>Copy Template</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-2 col-12">
                                    <p className="font-weight-semi-bold mt-2 mb-1 text-left">Name</p>
                                </div>
                                <div className="col-md-10 col-12">
                                    <div className="form-group mb-0">
                                        <input className="form-control mb-1" type="text" value={copyNewName} onChange={e => setCopyNewName(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button size="sm" variant='secondary' onClick={ () => {
                                setCopyId(null)
                                setCopyNewName(null)
                            } }>Cancel</Button>
                            <Button disabled={stringHelpers.isNullOrEmpty(copyNewName)} size="sm" variant='primary' onClick={ () => handleCopyConfirm() }>Confirm</Button>
                        </Modal.Footer>
                    </Modal>
                }

                {
                    !stringHelpers.isNullOrEmpty(errorMessage) &&
                    <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />
                }
            </div>
        </>
    )
}